<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-img"><img alt="image" src="images/img41.jpg"/></p>
<p class="chap"><a id="ch19"></a>ROGER WILLIAMS AND RHODE ISLAND, 1645</p>
<p class="noindent"><span class="big">E</span>nglish Puritan preacher Roger Williams immigrated to Massachusetts in 1631. Almost immediately, he began to clash with local leaders. Williams opposed government involvement in church affairs. Furthermore, he argued that the colony should not take land belonging to Native Americans unless they were paid.</p>
<p class="indent">Williams was banished from the colony in 1635, escaped south during the bitter winter, and settled in the region of Narragansett Bay near present-day Newport. He became friendly with the local American Indians and purchased from them land at the head of the bay, where he built the town of Providence. Rhode Island represented a unique stage in American constitutional evolution. It adopted the principles of complete religious freedom, toleration, and separation of church and state.</p>
<p class="indent">Williams, a prolific writer, spent the rest of his life writing and speaking his mind on religious freedom and became an outspoken advocate of fair treatment for Native Americans. <span class="color">(07-104, 07-105)</span></p>
<p class="image"><img alt="image" src="images/img42.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter019.vue?7c1f9e9d